export default "__VITE_ASSET__BzeCtqG$__"